/* eslint-disable no-magic-numbers */

import {
	aspectRatioRange,
	dimensions,
	filesize
} from "widgets/forms/validators/Assets";
import { requiredAsset, validateUnlessExternalRender } from "social/validators/validators";
import {
	isProtocolOptionalURL,
	isURL,
	maxLength,
	requiredNotNull
} from "widgets/forms/validators/validators";
import { uniquePACVariableName } from "widgets/social2/validators/utils";

import { MAX_IMAGE_BYTES } from "./consts";

export const staticValidators = {
	image: [uniquePACVariableName],
	headline: [uniquePACVariableName],
	primaryText: [uniquePACVariableName],
	landingPage: [uniquePACVariableName],
	displayLink: [uniquePACVariableName],
};

export const validators = {
	image: validateUnlessExternalRender([
		requiredAsset,
		filesize({ max: MAX_IMAGE_BYTES }),
		dimensions({ minWidth: 500 }),
		aspectRatioRange(0.8, 1.91, 0.03, { min: "4:5", max: "1.91:1" }),
	]),
	primaryText: [
		maxLength(2200),
	],
	landingPage: [
		requiredNotNull,
		isURL,
	],
	displayLink: [
		isProtocolOptionalURL,
	],
};
